import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "code-mirror code-mirror-container" }
const _hoisted_2 = { class: "codemirror-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RcCodeMirror = _resolveComponent("RcCodeMirror")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RcCodeMirror, {
        "model-value": _ctx.value,
        language: _ctx.language,
        keymap: _ctx.keymap,
        theme: "rancher",
        variant: _ctx.variant,
        "read-only": _ctx.isReadOnly,
        "line-numbers": _ctx.lineNumbers,
        "fold-gutter": _ctx.foldGutter,
        "line-wrapping": _ctx.lineWrapping,
        "keymap-indicator": _ctx.showKeyMapBox,
        "search-open": _ctx.searchOpen,
        linter: _ctx.linter,
        extensions: _ctx.combinedExtensions,
        "aria-label": _ctx.options.screenReaderLabel,
        onReady: _ctx.onReady,
        "onUpdate:modelValue": _ctx.onInput,
        onFocus: _ctx.onFocus,
        onBlur: _ctx.onBlur
      }, null, 8, ["model-value", "language", "keymap", "variant", "read-only", "line-numbers", "fold-gutter", "line-wrapping", "keymap-indicator", "search-open", "linter", "extensions", "aria-label", "onReady", "onUpdate:modelValue", "onFocus", "onBlur"])
    ])
  ]))
}